module.exports = __webpack_public_path__ + "static/media/nationwide-coverage.9f6a9a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nationwide-coverage.png
// module id = 987
// module chunks = 0